module.exports = flarum.core.compat['common/dianLiang/PayConfirmModal'];